import { render, staticRenderFns } from "./productMultiattribute.vue?vue&type=template&id=c5e87554&scoped=true&"
import script from "./productMultiattribute.vue?vue&type=script&lang=js&"
export * from "./productMultiattribute.vue?vue&type=script&lang=js&"
import style0 from "./productMultiattribute.vue?vue&type=style&index=0&id=c5e87554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e87554",
  null
  
)

export default component.exports